<template>
    <div id="app">
        <app-nav />
        <router-view />
        <app-footer />
        <modal-contact-form />
    </div>
</template>

<script>
import AppFooter from '@/components/global/AppFooter';
import AppNav from '@/components/global/AppNav';
import ModalContactForm from '@/components/global/ModalContactForm';

export default {
    components: {
        AppFooter,
        AppNav,
        ModalContactForm,
    },
};
</script>

<style lang="scss">
#app {
    font-family: 'Lato', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
